export default "__VITE_ASSET__abc4ebb3__"